module.exports = __webpack_public_path__ + "_/skins/XMMS-Turquoise-46ab165b574d97e2e51b22cb47a7661c.wsz";